export default __webpack_public_path__ + "static/media/logoL.a3527641.svg";